$(document).ready(function(){
  // recipient-form js
  $(document).on('change','.gift_card-field input#for_someone',function(){
    var selctedVal = $(this).val();
    if($(this).is(':checked')){
      $('.recipient-form label').addClass('active__checkbox');
      $('.recipient-form input').prop('checked',true);
      $('.egift-card-1 .product-form__input label[for]:eq(0)').addClass('active_checked');
      $('.egift-card-1 .product-form__input label[for]:eq(0)').trigger('click');
    }else{
      $('.recipient-form label').removeClass('active__checkbox');
      $('.recipient-form input').prop('checked',false);
      $('.egift-card-1 .product-form__input label').removeClass('active_checked');
      $('.egift-card-1 .product-form__input label input').prop('checked',false);
      $('.egift-card-1').find('.product-form input[name="id"]').val('');
      if($('.gift_card-field input#for_myself').is(':checked')){
        var variantIdGift = $('.gift_card-field input#for_myself').data('id');
        var mainId = $('.egift-card-1').find('.product-form input[name="id"]').val();
        if(mainId == '' || mainId == null ){
           $('.egift-card-1').find('.product-form input[name="id"]').val(variantIdGift);
        }
      }
    }
  });
  // announcement js
  var speedCount = $(document).find('.announcement-bar').data('speed');
  var speed = speedCount * 1000;
  $('.slider-bar').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    speed: 200,
    fade: true,
    arrows: true,
    autoplaySpeed: speed,
    autoplay: true,
    cssEase: 'ease',
    prevArrow:'<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }
  ]
  });
  $('.slider-column').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow:'<button type="button" class="slick-prev"><svg class="slideshow-arrow" width="23" height="39" viewBox="0 0 23 39" style="transform: scaleX(-1) scale(1);"><path d="M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z" transform="translate(-855 -230)"></path></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg class="slideshow-arrow" width="23" height="39" viewBox="0 0 23 39" style="transform: scaleX(1) scale(1);"><path d="M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z" transform="translate(-855 -230)"></path></svg></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
   // Fancybox Config
  $('.product_item_slide [data-fancybox="gallery"]').fancybox({
    buttons: [
      "close"
    ],
    loop: false,
    infobar: false,
    protect: true
  });
  // faq js
  $('.categories-tab-list .tab_btn:first-child').addClass('active');
  $('.accordian_tabs-conetnt').hide();
  $('.accordian_tabs-conetnt:first').show();

  $('.categories-tab-list .tab_btn').click(function(){
    $('.categories-tab-list .tab_btn').removeClass('active');
    $(this).addClass('active');
    var tabId = $(this).data('id');
    $('.accordian_tabs-conetnt').hide();
    $('.accordian_tabs-conetnt[data-id="'+tabId+'"]').show();
  });

  // Fancybox Config
  $('.slider_img [data-fancybox="gallery"]').fancybox({
    buttons: [
      // "slideShow",
      // "thumbs",
      // "zoom",
      // "fullScreen",
      // "share",
      "close"
    ],
    loop: false,
    infobar: false,
    protect: true
  });
  // product review blank hide
  function infinite_forever(){
    if ($(document).find('.okeReviews[data-oke-container]').find('.oke-is-clickable').length == 0){
      $(document).find('.okeReviews[data-oke-container]').addClass('hide_review');
    }
  }
  setInterval(function() {
        infinite_forever();
  }, 1000);
 
   
// atg base slider js
  if($(document).find('.template-product').length == 1){
$('.not_productalt.main-product-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    fade: false,
    speed: 300,
    focusOnSelect: false,
    asNavFor: '.not_productalt.main-thumbnail-list',
    adaptiveHeight: true,
    draggable: false
});
  $('.not_productalt.main-thumbnail-list').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      asNavFor: '.not_productalt.main-product-list',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M15.5 18L9.5 12L15.5 6" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M9.5 18.2087L15.5 12.2087L9.5 6.20874" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
      ]
    });
  var checkValM = $('variant-radios .product-form__input input[type="radio"]:checked').data('id');
   $(document).find('.not_productalt li').each(function(){
    var dataMedia = $(this).data('media');
    if(checkValM == dataMedia){
      var indexData = $(this).data('index');
      $('.not_productalt.main-thumbnail-list').slick('slickGoTo', indexData);
    }
  });  
  $(document).on('change','variant-radios .product-form__input input[type="radio"]',function() {
    var dataId = $(this).data('id');
    $(document).find('.not_productalt li').each(function(){
      var dataMedia = $(this).data('media');
      if(dataId == dataMedia){
        var indexData = $(this).data('index');
        $('.not_productalt.main-thumbnail-list').slick('slickGoTo', indexData);
      }
    });
  });
 if($('.product-form__input input.color_swatch-input').length > 1){  
  var checkVal = $('.product-form__input input.color_swatch-input:checked').val();
  var color = checkVal.split('(');
  var Colormain = color[0];
  if($('.product_tag-alt .main-product-list[data-slider="'+Colormain+'"]').length == 1){
   $('.product_tag-alt .main-product-list').removeClass('altTag');
    $('.product_tag-alt .main-thumbnail-list').removeClass('altTag');
      $('.product_tag-alt .main-product-list[data-slider="'+Colormain+'"]').addClass('altTag');
      $('.product_tag-alt .main-thumbnail-list[data-slider="'+Colormain+'"]').addClass('altTag');
   $('.altTag.main-product-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      fade: false,
      focusOnSelect: false,
      asNavFor: '.altTag.main-thumbnail-list',
      adaptiveHeight: true,
      draggable: false
    });
    $('.altTag.main-thumbnail-list').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      asNavFor: '.altTag.main-product-list',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M15.5 18L9.5 12L15.5 6" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M9.5 18.2087L15.5 12.2087L9.5 6.20874" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
      ]
    });
  }else{
     $('.product_tag-alt .main-product-list').removeClass('altTag');
    $('.product_tag-alt .main-thumbnail-list').removeClass('altTag');
    $('.main_product[data-index="1"]').find('.main-product-list').addClass('altTag');
    $('.main_thumnail[data-index="1"]').find('.main-thumbnail-list').addClass('altTag');
    $('.altTag.main-product-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      fade: false,
      focusOnSelect: false,
      asNavFor: '.altTag.main-thumbnail-list',
      adaptiveHeight: true,
      draggable: false
    });
    $('.altTag.main-thumbnail-list').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      asNavFor: '.altTag.main-product-list',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M15.5 18L9.5 12L15.5 6" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M9.5 18.2087L15.5 12.2087L9.5 6.20874" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
      ]
    });
  }
 }else{
    $('.product_tag-alt .main-product-list').removeClass('altTag');
    $('.product_tag-alt .main-thumbnail-list').removeClass('altTag');
    $('.main_product[data-index="1"]').find('.main-product-list').addClass('altTag');
    $('.main_thumnail[data-index="1"]').find('.main-thumbnail-list').addClass('altTag');
    $('.altTag.main-product-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      fade: false,
      focusOnSelect: false,
      asNavFor: '.altTag.main-thumbnail-list',
      adaptiveHeight: true,
      draggable: false
    });
    $('.altTag.main-thumbnail-list').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      asNavFor: '.altTag.main-product-list',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M15.5 18L9.5 12L15.5 6" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M9.5 18.2087L15.5 12.2087L9.5 6.20874" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
      ]
    });
  }
 
 $(document).on('change','.product-form__input .color_swatch-input',function() {
   $(document).find('html,body').css("scroll-behavior", "unset");
   // $(this).prop('selected',true);

    var checkVal = $(this).val();
    var color = checkVal.split('(');
    var Colormain = color[0];
    if($('.product_tag-alt .main-product-list[data-slider="'+Colormain+'"]').length == 1){
    // $('.product_tag-alt .main-product-list,.product_tag-alt .main-thumbnail-list').hide();
    $('.altTag.main-product-list').slick('unslick');
    $('.altTag.main-thumbnail-list').slick('unslick');
    $('.product_tag-alt .main-product-list').removeClass('altTag');
    $('.product_tag-alt .main-thumbnail-list').removeClass('altTag');
    $('.product_tag-alt .main-product-list[data-slider="'+Colormain+'"]').addClass('altTag');
    $('.product_tag-alt .main-thumbnail-list[data-slider="'+Colormain+'"]').addClass('altTag');

      window.scroll(0,0);
   
      $('.altTag.main-product-list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        focusOnSelect: false,
        asNavFor: '.altTag.main-thumbnail-list',
        adaptiveHeight: true,
        draggable: false
      });
      $('.altTag.main-thumbnail-list').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.altTag.main-product-list',
        dots: false,
        infinite: false,
        centerMode: false,
        focusOnSelect: true,
        prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M15.5 18L9.5 12L15.5 6" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M9.5 18.2087L15.5 12.2087L9.5 6.20874" stroke="#123132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
        ]
      });
      // setTimeout(()=>{
      //   $('.altTag.main-product-list,.altTag.main-thumbnail-list').show();
      //   $('.altTag.main-thumbnail-list').slick('refresh');
      //   $('.altTag.main-product-list').slick('refresh');
      // },100);
    }
  });
  }

  function infinite_forever_quick(){
     $(document).on('click','.particular_btn .text_area',function(){
      $(this).addClass('text-length');
    });
    $('.particular_btn .text_area').on('keyup', function() {
      var TextVal = $(this).val().length;
      var valSpan = $(this).attr('maxlength');
      var counttext = valSpan - TextVal;
      $('.particular_btn').find('.placeholder_text').text(counttext);
    });
    $(document).on('click','.silhouette_btn .text_area',function(){
      $(this).addClass('text-length');
    });
    $('.silhouette_btn .text_area').on('keyup', function() {
      var TextVal = $(this).val().length;
      var valSpan = $(this).attr('maxlength');
      var counttext = valSpan - TextVal;
      $('.silhouette_btn').find('.placeholder_text').text(counttext);
    });
    $('.particular_btn textarea,.silhouette_btn textarea,.date_field input,.shipping_kit select,.art_glass select,.flowers_kit select').on("focus", function() {
      $(this).parents('.field-btn').find('.error-show').hide(); 
    });
    
  $(document).mouseup(function(e){
    var container = $('.text_area');
    if(!container.is(e.target) && container.has(e.target).length === 0){
       $('.text_area').removeClass('text-length');
    }
  });
  }
  setInterval(function() {
    infinite_forever_quick();
  }, 1000);
 

   $(document).on('change','.quick-add-modal .product-form__input[data-option="option-1"] input',function() {
      var valueOption =  $(this).data('title');
      var valueOne = $(this).val();
      $(this).closest('.quickBuy--item-variants').find('.product--form-select[data-option="option-1"] .quick_view-option option[data-title="'+valueOption+'"]').prop('selected',true);
      $(this).closest('.quickBuy--item-variants').find('.product--form-select[data-option="option-1"] .quick_view-option option[data-title="'+valueOption+'"]').trigger('change');
      $('.product-form__input[data-option="option-1"]').find('.selected__value').text('('+ valueOne +')');
    });
     $(document).on('change','.quick-add-modal .product-form__input[data-option="option-2"] input',function() {
      var valueOption =  $(this).data('title');
      var valueOne = $(this).val();
      $(this).closest('.quickBuy--item-variants').find('.product--form-select[data-option="option-2"] .quick_view-option option[data-title="'+valueOption+'"]').prop('selected',true);
      $(this).closest('.quickBuy--item-variants').find('.product--form-select[data-option="option-2"] .quick_view-option option[data-title="'+valueOption+'"]').trigger('change');
      $('.product-form__input[data-option="option-2"]').find('.selected__value').text('('+ valueOne +')');
    });
     $(document).on('change','.quick-add-modal .product-form__input[data-option="option-3"] input',function() {
      var valueOption =  $(this).data('title');
      var valueOne = $(this).val();
      $(this).closest('.quickBuy--item-variants').find('.product--form-select[data-option="option-3"] .quick_view-option option[data-title="'+valueOption+'"]').prop('selected',true);
      $(this).closest('.quickBuy--item-variants').find('.product--form-select[data-option="option-3"] .quick_view-option option[data-title="'+valueOption+'"]').trigger('change');
      $('.product-form__input[data-option="option-3"]').find('.selected__value').text('('+ valueOne +')');
    });
    
  if(location.hash){
   $(document).on("click",".footer-block__details-content li a",function (e) {
      var selector = $(this).attr("href");
      var selectorSplit = selector.split('#');
      var selectorhash = selectorSplit[1];
    setTimeout(() =>{
      var scr = document.querySelector('#'+selectorhash).offsetTop;
     console.log(scr);
      scr = scr-75;
      window.scroll(0,scr);
     }, 100);
    });
  }

  $(".quick_link .hashtag").click(function(event) {
    event.preventDefault();
      $(document).find('html,body').css("scroll-behavior", "unset");
      var hashvar = $(this).attr('href');
      var selectorSplit = hashvar.split('#');
      var selectorhash = selectorSplit[1];
      $('html, body').animate({
        scrollTop: $(".product_main").find('#'+selectorhash ).offset().top
      }, 3000);
  });

  $(".sort_listings a").click(function(event) {
    event.preventDefault();
      $(document).find('html,body').css("scroll-behavior", "unset");
      var hashvar = $(this).attr('href');
      var selectorSplit = hashvar.split('#');
      var selectorhash = selectorSplit[1];
      $('html, body').animate({
        scrollTop: $(".column-grid-list ").find('.column-grid-list__item[data-attr="'+selectorhash +'"]').offset().top-75
      }, 3000);
  });

  /* init Jarallax */
  jarallax(document.querySelectorAll(".jarallax"));
  
  jarallax(document.querySelectorAll(".jarallax-keep-img"), {
    keepImg: true,
  });

   $('.required_inputmain').on("focus", function() {
      $(this).parents('.field-btn').find('.error_show_form').hide(); 
   });

   $(document).on('change','#itg_img_upload',function(){
      if($(this).val() != '' ){
         $('#getfile').val('');
          $(document).find("#response_text").css("display", "block");
          //$(document).find("#response_text_suc").css("display", "none");
         var form_data = new FormData();
         var file_data = $('#itg_img_upload').prop("files")[0];
         form_data.append("image", file_data);
         //$(document).find(".loader-bg").css("display", "flex");
         $.ajax({
              type: 'POST',
              url: 'https://dev.shopifyexperthelp.com/app/project_app/shopify/upload.php',
              data:form_data,
              contentType: false,
              cache: false,
              processData:false,
              success: function(response){
                $('#getfile').val(response);
                $(document).find('.final_image').attr("src",'');
                $(document).find("#response_text").css("display", "none");
                //$(document).find("#response_text_suc").css("display", "block");
                $(document).find('.final_image').attr("src",response);
                $(document).find('.final_image').css("display", "block");
              },error: function(params) {
                alert('errror');
              }
          });
      }
   });
  $(document).on('click','.upload-button',function(){
    $('.input_file-change').trigger('click');
    $('.error_show_form').hide(); 
  });
  $(document).on('click','.checkout_btn button',function(){
    var check = 1;

    $('.required_inputmain').each(function(){
      var val = $(this).val();
      if(val == '' || val == null){
        check = 0;
        $(this).parents('.field-btn').find('.error_show_form').show();
      }else{
        $(this).parents('.field-btn').find('.error_show_form').hide();
      }
    });
  
    if(check == 0){
      return false;
    } 
    var varianId = $(this).data('id');
    var wedding = $('.florist_field #date').val();
    var florist = $('.florist_field #florist').val();
    var size = $('.florist_field #size').val();
    var bouquet = $('.florist_field #bouquet').val(); 
    var getfile = $('#getfile').val();
    
    var properties = {
    "When was your wedding/event?]": wedding,
    "What size and type of frame(s) are you interested in?": size ,
     "What flowers & elments were apart of your bouquet? If you don't know the specifics, no worries, we will be able to help you determine which flowers you need.": bouquet,
     "Please upload a photo of the original bouquet. (Unedited photo preferred.)": getfile 
    }
    var isValid = Object.values(properties).every(function (value) {
      return value.trim() !== ''; // Assuming properties should not be blank
    });
        
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: varianId,
        properties: properties
      },
      dataType: 'json', 
      async: false,
      success: function(data){
        window.location.href = '/checkout';
     
      },
      error: function() {
        alert("Item is out of stock");
      }
    })
  });

 $(document).find("#random_number").attr('name','');
  $(document).on('change','.shipping_kit.field-btn select.required_field,.art_glass.field-btn select.required_field,.recipient_grid input,.flowers_kit.field-btn select.required_field',function() {
   var shippingKit = $(document).find(".shipping_kit.field-btn select option:selected").attr('data-number');
   var art_glass = $(document).find(".art_glass.field-btn select option:selected").attr('data-number');
   var flower_n = $(document).find(".flowers_kit.field-btn select option:selected").attr('data-number');
   var gift_add = $(document).find(".recipient_grid input:checkbox").attr('data-number');
   if(shippingKit != '' || art_glass != '' || gift_add != '' || flower_n != '' ){
     $(document).find("#random_number").attr('name','properties[_Rno]');
   }else{
     $(document).find("#random_number").attr('name','');
   }
  });

$( function() {

    var targets = $('.tooltip'),
        target  = false,
        tooltip = $('.tooltiptext'),
        title   = false;

    targets.bind( 'click', function()
    {
        target  = $( this );
        tip     = target.children('.tooltiptext');
        tooltip = $( '<div id="tooltip" class="toolTip-custom"></div>' );

        if( !tip || tip == '' )
            return false;

        //target.remove('.mbt-tooltip');
        //target.removeAttr( 'title' );
        tooltip.css( 'opacity', 0 )

               .html( tip.clone().show() )

               .appendTo( 'body' );

        var init_tooltip = function()
        {
            if( $( window ).width() < tooltip.outerWidth() * 1.5 )
                tooltip.css( 'max-width', $( window ).width() / 1.5 );
            else
                tooltip.css( 'max-width', 340 );

            var pos_left = target.offset().left + ( target.outerWidth() / 2 ) - ( tooltip.outerWidth() / 2 ),
                pos_top  = target.offset().top - tooltip.outerHeight() - 20;

            if( pos_left < 0 )
            {
                pos_left = target.offset().left + target.outerWidth() / 2 - 20;
                tooltip.addClass( 'left' );
            }
            else
                tooltip.removeClass( 'left' );

            if( pos_left + tooltip.outerWidth() > $( window ).width() )
            {
                pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
                tooltip.addClass( 'right' );
            }
            else
                tooltip.removeClass( 'right' );

            if( pos_top < 0 )
            {
                var pos_top  = target.offset().top + target.outerHeight();
                tooltip.addClass('top' );
            }
            else
                tooltip.removeClass('top');

            tooltip.css( { left: pos_left, top: pos_top } )
                   .animate( { top: '+=10', opacity: 1 }, 50 );
        };

        init_tooltip();
        $( window ).resize( init_tooltip );


       var remove_tooltip = function()
        {
            tooltip.animate( { top: '-=10', opacity: 0 }, 300, function()
            {
                $( this ).remove();
            });

            target.children('.tooltiptext', tip);

        };

        //**** ISSUE AREA ****//
        // target.bind( 'mouseleave', remove_tooltip );
        tooltip.bind( 'click', remove_tooltip );
    });
});
$(document).mouseup(function(e) {
  var container = $('.toolTip-custom');
  if (!container.is(e.target) && container.has(e.target).length === 0){ 
     $('.toolTip-custom').remove();
  }
});
  
  $(document).on('change','.date_field input[type="date"]',function(){
      var selectedDate = new Date($(this).val());
      var selectDate = selectedDate.getDate();
      var today = new Date();
      var day = today.getDate();
      var dateDifference = Math.round((selectedDate - today) / (1000 * 60 * 60 * 24)); // Difference in days
      dateDifference = dateDifference + 1;
      if (dateDifference >= 14 && dateDifference > 0 ) {
        // $(document).find(".shipping_kit ").removeClass('ship_disabled');
        // console.log("Date selected is within 14 days from today.");
         $(document).find(".shipping_kit").find('.field_select').empty();
        var selectHtml = $(document).find(".shipping_kit .shippingkit_hidden").html();
        $(document).find(".shipping_kit ").find('.field_select').append(selectHtml);
      } else {
        $(document).find(".shipping_kit").find('.field_select').empty();
        var selectHtml = $(document).find(".shipping_kit .field_select_hidden").html();
        $(document).find(".shipping_kit").find('.field_select').append(selectHtml);
        // $(document).find(".shipping_kit ").addClass('ship_disabled');
        // console.log("Date selected is more than 14 days from today.");
      }
    
  });

 
  if($('body').hasClass('template-index')){
    var loactionHref = window.location.href;
    if(loactionHref == 'https://flowersofthepress.myshopify.com/?contact_posted=true'){
      $(document).find('html,body').css("scroll-behavior", "unset");
      var hashvar = $('.custom_order-form').find('form').attr('id');
      setTimeout(()=>{
      let scrTop = $('.custom_order-form').find('#'+hashvar ).offset().top - 300;
      window.scroll(0,scrTop);
      },2000)
    }
  }
  
});
$(document).on('click','.recipient-fields__field .text-area',function(){
  $(this).addClass('text-length');
});
$(document).mouseup(function(e){
  var container = $('.recipient-fields__field .text-area');
  if(!container.is(e.target) && container.has(e.target).length === 0){
     $('.recipient-fields__field .text-area').removeClass('text-length');
  }
});


$(document).on('change','.gift_card-field .field_checked input',function(){
  if($('.gift_card-field input#for_myself').is(':checked')){
    $('.desc_addon').show();
    var variantIdGift = $('.gift_card-field input#for_myself').data('id');
    var mainId = $('.egift-card-1').find('.product-form input[name="id"]').val();
    if(mainId == '' || mainId == null ){
       $('.egift-card-1').find('.product-form input[name="id"]').val(variantIdGift);
    }
  }else{
    $('.desc_addon').hide();
  }
});
$(document).on('click','.egift-card-1 .product-form__input label',function(){
  $('.recipient-form label').addClass('active__checkbox');
  $('.egift-card-1 .product-form__input label').removeClass('active_checked');
  $(this).addClass('active_checked');
  $('.egift-card-1 .gift_card-field').find('input#for_someone[type="checkbox"]').prop('checked', true);
});

var clslength = $(".main-product__layout").hasClass("egift-card-1");
if(clslength){
  $('.egift-card-1').find('.product-form input[name="id"]').val('');
  $('.egift-card-1').find('.product-form__input input[type="radio"]').prop('checked', false);
}


